import { axios } from '../util/axios'
import SmartLock from '../util/smartLock'
import lastLoginStorage from '../util/lastLoginStorage'

const platform = 'WEB'
const smartLock = new SmartLock('login')

export const sendEmailPincodeRequest = email =>
  axios.post(
    '/v0/user/send_pincode_login',
    {
      email,
    },
    {
      withCredentials: false,
    }
  )

export const checkEmailPincodeRequest = (code, token, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-email_pincode'

  return axios
    .post(
      '/v2/user/login/email_pincode',
      {
        code,
        token,
        platform,
        session_ids: sessionTokens,
      },
      {
        headers: {
          'X-TestAB-Groups': abTests,
        },
      }
    )
    .then(async ({ data }) => {
      const { fullName = '', email = '' } = data
      lastLoginStorage.saveEmailLogin(email)
      await smartLock.saveCredential(email, fullName)
      return data
    })
}

export const checkEmailPincodeRequestRevalidation = (code, token, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-email_pincode'

  return axios
    .post('/v3/user/login/email_pincode', {
      code,
      token,
      platform,
      session_ids: sessionTokens,
    })
    .then(async ({ data }) => {
      const { fullName = '', email = '' } = data
      lastLoginStorage.saveEmailLogin(email)
      await smartLock.saveCredential(email, fullName)
      return data
    })
}
